var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"name":_vm.name},domProps:{"value":_vm.currentVal},on:{"change":function($event){return _vm.changeval($event.target.value)}}},_vm._l((_vm.categorylist),function(cat){return _c('option',{key:cat.RowKey,domProps:{"value":cat.RowKey,"selected":_vm.isSelected(cat)}},[_vm._v(_vm._s(cat.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }